import React, { Component } from "react";
import { Route, Redirect } from 'react-router'
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Grid,
  Divider,
  Switch,
  TextField,
  Typography,
  colors
} from "@material-ui/core";
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { toast } from "react-toastify";
import axios from "axios";
import { TablePagination } from 'react-pagination-table';
import _apiData from "../../metaData";
let apiData = _apiData[0];
console.log(apiData, "apiData");

const TableHeader = ["Username", "FirstName", "LastName", "Client", "Status", "Actions"];

export default class EditUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      agentRole: "",
      searchText: "Search",
      searchData: {},
      showDetails: false,
      fullUserList: null,
      userList: null,
      clients: null,
      statuses: ["All Status", "blocked", "active"],
      client_filter: "",
      selectedClient: "",
      selectedStatus: ""
    };
  }

  componentDidMount(){
    let client = JSON.parse(localStorage.getItem("loginDetails")).user.clientId
    axios.get(apiData.ward_report_users.url, {
        params: {
          work_order: apiData.ward_report_users.params.work_order,
          clients: [client]
        },
        headers: apiData.headers
      })
      .then(res => {
        if(res.data.response){
          let userList = [];
          let clientNames = Object.keys(res.data.response.results);
          this.setState({clients: ["All Clients", ...clientNames]})
          for(let i = 0; i < clientNames.length; i++){
            let clientUsers = res.data.response.results[clientNames[i]];
            clientUsers = clientUsers.map(item => {
              return {
                ...item,
                clientName: clientNames[i],
                Actions: <div style={{display: 'flex', justifyContent: 'space-around'}}><div onClick={() => this.handleEdit(item.username)} style={{backgroundColor: "#e8796a", color: 'white', padding: '4px', borderRadius: '3px'}}><EditIcon/></div> <div onClick={() => this.handleDelete(item.username)} style={{backgroundColor: "#e8796a", color: 'white', padding: '4px', borderRadius: '3px'}}><DeleteIcon/></div></div>
              }
            })
            userList = [...userList, ...clientUsers]
          }
          this.setState({userList: userList})
          this.setState({fullUserList: userList})
        }
      })
  }

  handleAddNew() {
    this.props.history.push("/addUser")
  }

  handleEdit(username) {
    this.props.history.push({
      pathname: "/editUser",
      state: {username} 
    })
  }

  handleDelete(username) {
    this.props.history.push({
      pathname: "/deleteUser",
      state: {username} 
    })
  }

  submitAgent(e) {
    if (!this.state.agentRole) {
      toast.error("Please Select Role!", {
        position: toast.POSITION.TOP_RIGHT
      });
    } else {
      console.log("submit..");
      let data = {};
      data.username = this.state.searchData.userName;
      data.user_type = this.state.agentRole;
      axios
        .put(apiData.userDetails.url, data, {
          headers: apiData.headers
        })
        .then(res => {
          console.log(res, "submit put res");
          if (res.data.ok) {
            toast.success("Edited Sucessfully!", {
              position: toast.POSITION.TOP_RIGHT
            });
            this.setState({
              showDetails: false,
              agentRole: ""
            });
          } else {
            toast.error(
              res.data.error.reason
                ? res.data.error.reason
                : "User Not Found !",
              {
                position: toast.POSITION.TOP_RIGHT
              }
            );
          }
        });
    }
  }
  searchClick(e) {
    console.log(this.state.searchMobile, "mobile");
    this.setState({
      searchText: "Loading..."
    });
    if (this.state.searchMobile) {
      let params = {};
      params.username = this.state.searchMobile;
      console.log(params, "paraaamss");
      axios
        .get(apiData.userDetails.url, {
          params: { username: this.state.searchMobile },
          headers: apiData.headers
        })
        .then(res => {
          console.log(res, "ress");
          this.setState({
            searchText: "Search"
          });
          if (res.data.ok) {
            console.log(res.data.response.userObj, "res.dataoop");
            let response = res.data.response.userObj;
            let showObj = {};
            showObj.mobile = response.primary_phone
              ? response.primary_phone
              : "-";
            showObj.email = response.email ? response.email : "-";
            showObj.firstName = response.first_name;
            showObj.lastName = response.last_name;
            showObj.userType = response.user_type;
            showObj.userName = response.username;
            showObj.clientName = response.client_name
              ? response.client_name
              : "-";
            showObj.apps = response.assigned_apps;
            showObj.projects = response.assigned_prefixCodes;
            console.log(showObj, "showObj");
            this.setState({
              searchData: showObj,
              showDetails: true
            });
          } else {
            this.setState({
              showDetails: false
            });
            toast.error(
              res.data.error.reason
                ? res.data.error.reason
                : "User Not Found !",
              {
                position: toast.POSITION.TOP_RIGHT
              }
            );
          }
        });
    } else {
      toast.error("Please Enter Mobile/UserName !", {
        position: toast.POSITION.TOP_RIGHT
      });
    }
  }

  clientFilter = (e) => {
    if(e.target.value === "All Clients" && !this.state.selectedStatus){
      this.setState({
        userList: this.state.fullUserList,
        selectedClient: ""
      })
    } else if (e.target.value === "All Clients" && this.state.selectedStatus) {
      let filteredList = this.state.fullUserList.filter(item => item.user_status === this.state.selectedStatus);
      this.setState({
        userList: filteredList,
        selectedClient: ""
      })
    } else if (e.target.value !== "All Clients" && this.state.selectedStatus) {
      let filteredList = this.state.fullUserList.filter(item => item.user_status === this.state.selectedStatus && item.clientName === e.target.value);
      this.setState({
        userList: filteredList,
        selectedClient: e.target.value
      })
    } else if (e.target.value !== "All Clients" && !this.state.selectedStatus) {
      let filteredList = this.state.fullUserList.filter(item => item.clientName === e.target.value);
      this.setState({
        userList: filteredList,
        selectedClient: e.target.value
      })
    }
  }

  statusFilter = (e) => {
    if(e.target.value === "All Status" && !this.state.selectedClient){
      this.setState({
        userList: this.state.fullUserList,
        selectedStatus: ""
      })
    } else if (e.target.value === "All Status" && this.state.selectedClient) {
      let filteredList = this.state.fullUserList.filter(item => item.clientName === this.state.selectedClient);
      this.setState({
        userList: filteredList,
        selectedStatus: ""
      })
    } else if (e.target.value !== "All Status" && this.state.selectedClient) {
      let filteredList = this.state.fullUserList.filter(item => item.clientName === this.state.selectedClient && item.user_status === e.target.value);
      this.setState({
        userList: filteredList,
        selectedStatus: e.target.value
      })
    } else if (e.target.value !== "All Status" && !this.state.selectedClient) {
      let filteredList = this.state.fullUserList.filter(item => item.user_status === e.target.value);
      this.setState({
        userList: filteredList,
        selectedStatus: e.target.value
      })
    }
  }

  render() {
    console.log(this.state.agentRole, "agentRole");
    console.log(this.state.userList)
    return (
      <div className="container hole-container" style={{ width: "76em" }}>
        <h6 className="page-header">List Agents</h6>
        <div className="row">
          <div class="form-group row col-md-10" style={{display: 'flex', alignItems: 'center'}}>
            
          </div>
          <div className="col-md-2">
            <Button
              variant="contained"
              color="primary"
              component="span"
              onClick={() => this.handleAddNew()}
              style={{background: "#e8796a"}}
            >
              + Add New
            </Button>
          </div>
        </div>

        <div className="row">
            {this.state.userList && <div class="form-group row col-md-10" style={{display: 'flex', alignItems: 'center'}}>
              <label className='col-sm-2 label' for="sel1">Client</label>
              <div className='col-sm-3'>
                <select class="form-control" id="sel1" onChange={this.clientFilter}>
                  {this.state.clients.map(item => {
                    return <option value={item} selected={this.state.client_filter == {item} ? 'selected' : ""}>{item}</option>
                  })}
                </select>
              </div>
              <label className='col-sm-2 label' for="sel1">Status</label>
              <div className='col-sm-3'>
                <select class="form-control" id="sel1" onChange={this.statusFilter}>
                  {this.state.statuses.map(item => {
                    return <option value={item} selected={this.state.client_filter == {item} ? 'selected' : ""}>{item}</option>
                  })}
                </select>
              </div>
            </div>}
          <div className="col-md-2">
            
          </div>
        </div>

        {this.state.userList && <div style={{marginTop: '20px', marginBottom: '20px'}}>
	        <TablePagination
              title=""
              // subTitle="Sub Title"
              headers={ TableHeader }
              data={ this.state.userList }
              columns="username.first_name.last_name.clientName.user_status.Actions"
              perPageItemCount={ 50 }
              totalCount={ this.state.userList.length }
              // arrayOption={ [["size", 'all', ' ']] }
	            paginationClassName="pagination"
            />
	    </div>}
      </div>
    );
  }
}
